import { useAuth } from '@/hooks/useAuth'
import { useCurrentCompanyUser } from '@/hooks/useCurrentCompanyUser'
import { useCurrentUserOrFail } from '@/hooks/useCurrentUserOrFail'

export function usePermissions() {
  const currentUser = useCurrentUserOrFail()
  const currentCompanyUser = useCurrentCompanyUser()
  const { currentCompany, currentGroup } = useAuth()
  const currentCompanyId = currentCompany?.id
  const currentGroupId = currentGroup?.id
  const permissions = currentUser.permissions

  return {
    canSearchPanels: permissions.includes(`c:${currentCompanyId}/panel/search`),
    canInviteToPanel: permissions.includes(
      `c:${currentCompanyId}/panel/invite`,
    ),
    canManageUsers:
      (currentGroup &&
        permissions.includes(`g:${currentGroupId}/user/admin`)) ||
      (currentCompany &&
        permissions.includes(`c:${currentCompanyId}/user/admin`)),
    canManageCompanyUsers: permissions.includes(
      `c:${currentCompanyId}/user/admin`,
    ),
    canManageCompanyPayments: permissions.includes(
      `c:${currentCompanyId}/user/payment-admin`,
    ),
    canManageJoinRequests: permissions.includes(
      `c:${currentCompanyId}/join-request/edit`,
    ),
    canManageGroupUsers: permissions.includes(`g:${currentGroupId}/user/admin`),
    canManageGroupPayments: permissions.includes(
      `g:${currentGroupId}/user/payment-admin`,
    ),
    canManageReferralApprovals: permissions.includes(
      `c:${currentCompanyId}/referral-approval-user/edit`,
    ),
    canAcceptReferrals: permissions.includes(
      `c:${currentCompanyId}/referral/accept`,
    ),
    canManagePaymentProfile: permissions.includes(
      `c:${currentCompanyId}/company/payment-profile`,
    ),
    canCreateCompany: permissions.includes(`company/create`),
    canViewJoinRequests: permissions.includes(
      `c:${currentCompanyId}/join-request/view`,
    ),
    canViewRecommendedPartners: permissions.includes(
      `c:${currentCompanyId}/recommended-partner/view`,
    ),
    canAddPanelDirectly: currentCompanyUser?.canAddPanelDirectly ?? false,
    canManageCommercialAgreements: !!currentCompanyUser?.isCompanyAdmin,
    isCompanyAdmin: currentCompanyUser?.isCompanyAdmin ?? false,
    isCompanyMeetingsAdmin: currentCompanyUser?.isCompanyMeetingsAdmin ?? false,
    canManageMeetings:
      (currentCompanyUser?.isCompanyAdmin ?? false) ||
      (currentCompanyUser?.isCompanyMeetingsAdmin ?? false),
  }
}
